// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate } from "react-router-dom";
// import "../assets/css/header.css";
// import UserProfileModal from "./UserProfileModal";

// const Header = ({ toggleSidebar }) => {
//   const navigate = useNavigate();
//   const [dateTime, setDateTime] = useState(new Date());
  
//   // FIX 1: Initialize state empty initially
//   const [usersData, setUserData] = useState(() => {
//   const storedUser = localStorage.getItem("user");
//   return storedUser ? JSON.parse(storedUser) : {}; 
// });
  
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [showProfileModal, setShowProfileModal] = useState(false);
//   const dropdownRef = useRef(null);

//   // FIX 2: Move localStorage logic inside useEffect
//   // useEffect(() => {
//   //   const storedUser = localStorage.getItem("user");
//   //   if (storedUser) {
//   //     setUserData(JSON.parse(storedUser));
//   //   }
//   // }, []); // Empty dependency array ensures this runs only once on mount

//   useEffect(() => {
//     const timer = setInterval(() => setDateTime(new Date()), 1000);
//     return () => clearInterval(timer);
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const formattedDate = dateTime.toLocaleDateString("en-GB", {
//     day: "numeric",
//     month: "short",
//     year: "numeric",
//   });
  
//   const formattedTime = dateTime.toLocaleTimeString("en-US", {
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit",
//     hour12: true,
//   });

//   const handleLogout = () => {
//     localStorage.removeItem("token");
//     localStorage.removeItem("dashboard_animation_played");
//     navigate("/login");
//     window.location.reload();
//   };

//   return (
//     <div className="header-area">
//       <div className="d-flex align-items-center">
//         <i className="bi bi-list menu-toggle" onClick={toggleSidebar}></i>
//       </div>

//       <div className="header-controls">
//         <div className="date-badge" title="Date">
//           <i className="bi bi-calendar"></i>
//           <span className="ms-2 date-text">{formattedDate}</span>
//         </div>

//         <div className="date-badge" title="Time">
//           <i className="bi bi-clock"></i>
//           <span
//             className="ms-2 time-text"
//             style={{ minWidth: "65px", display: "inline-block" }}
//           >
//             {formattedTime}
//           </span>
//         </div>

//         <div className="btn btn-light rounded-circle p-2 notification-btn">
//           <i className="bi bi-bell"></i>
//         </div>

//         {/* --- PROFILE DROPDOWN WRAPPER --- */}
//         <div className="profile-wrapper position-relative" ref={dropdownRef}>
//           <img
//             src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=100"
//             alt="Profile"
//             className={`profile-pic ${showDropdown ? "active" : ""}`}
//             onClick={() => setShowDropdown(!showDropdown)}
//           />

//           {showDropdown && (
//             <div className="profile-dropdown-menu">
//               <div className="dropdown-user-info">
//                 <div className="user-name">{usersData?.userName}</div>
//                 <div className="user-email">{usersData?.email}</div>
//               </div>

//               <div className="dropdown-divider"></div>
//               <div
//                 className="dropdown-item-custom d-flex align-items-center gap-3 p-2 rounded cursor-pointer hover-bg-light"
//                 style={{ cursor: "pointer", transition: "0.2s" }}
//                 onClick={() => {
//                   setShowProfileModal(true);
//                   setShowDropdown(false);
//                 }}
//               >
//                 <div className="icon-box text-primary">
//                   <i className="bi bi-person-gear"></i>
//                 </div>
//                 <span className="text-dark small fw-medium">Account</span>
//               </div>
            
//               <div className="dropdown-item-custom">
//                 <div className="icon-box">
//                   <i className="bi bi-sliders"></i>
//                 </div>
//                 <span>Settings</span>
//               </div>

//               <div className="dropdown-item-custom">
//                 <div className="icon-box">
//                   <i className="bi bi-graph-up-arrow text-primary"></i>
//                 </div>
//                 <span>Upgrade Plan</span>
//               </div>

//               <div className="dropdown-divider"></div>

//               <div
//                 className="dropdown-item-custom logout-item"
//                 onClick={handleLogout}
//               >
//                 <div className="icon-box">
//                   <i
//                     className="bi bi-box-arrow-right"
//                     style={{ color: "red" }}
//                   ></i>
//                 </div>
//                 <span style={{ color: "red" }}>Log out</span>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <UserProfileModal
//         show={showProfileModal}
//         onClose={() => setShowProfileModal(false)}
//         currentUser={usersData}
//       />
//     </div>
//   );
// };

// export default Header;

import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/header.css";
import UserProfileModal from "./UserProfileModal";
import WorkStatusDropdown from "./WorkStatusDropdown"; // <-- IMPORTED HERE
import HeaderClockButton from "./HeaderClockButton";

const Header = ({ toggleSidebar, isCollapsed, isMobile,onStatusChanged, workStatus, statusStartedAt}) => {
  const navigate = useNavigate();
  const [dateTime, setDateTime] = useState(new Date());
  
  // Initialize state empty initially
  const [usersData, setUserData] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : {}; 
  });
    console.log(usersData, '4334');
    
  const [showDropdown, setShowDropdown] = useState(false);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const dropdownRef = useRef(null);
  const [unreadCount, setUnreadCount] = useState(2);

  useEffect(() => {
    const timer = setInterval(() => setDateTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const formattedDate = dateTime.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
  
  const formattedTime = dateTime.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("dashboard_animation_played");
    navigate("/login");
    window.location.reload();
  };

  return (
    <div className={`header-area ${isCollapsed ? "collapsed" : ""}`}>
      <div className="header-left">
       {!(isMobile && !isCollapsed) && (
    <i
        className={`bi bi-list menu-toggle ${
            isCollapsed ? "collapsed" : ""
        }`}
        onClick={toggleSidebar}
    ></i>
)}
      </div>
      
      {/* --- RIGHT SIDE LAYOUT --- */}
      <div className="header-controls d-flex align-items-center gap-3">
        
        {/* Clock In/Out button — shown in the header on all screens */}
        <HeaderClockButton />

        {/* 1. STATUS DROPDOWN (Added here to show first) */}
  <WorkStatusDropdown
  currentUser={usersData}
  onStatusChanged={onStatusChanged}
/>

        {/* 2. DATE */}
        <div className="date-badge" title="Date">
          <i className="bi bi-calendar"></i>
          <span className="ms-2 date-text">{formattedDate}</span>
        </div>

        {/* 3. TIME */}
        <div className="date-badge" title="Time">
          <i className="bi bi-clock"></i>
          <span
            className="ms-2 time-text"
            style={{ minWidth: "65px", display: "inline-block" }}
          >
            {formattedTime}
          </span>
        </div>

        {/* 4. NOTIFICATIONS */}
        {/* <div className="btn btn-light rounded-circle p-2 notification-btn position-relative">
          <i className="bi bi-bell"></i>
          </div> */}
          {/* Optional: Add a red dot for unread notifications here if needed in the future */}
        

        {/* 5. PROFILE DROPDOWN WRAPPER */}
        <div className="profile-wrapper position-relative" ref={dropdownRef}>
          <img
            src="https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=100"
            alt="Profile"
            className={`profile-pic ${showDropdown ? "active" : ""}`}
            onClick={() => setShowDropdown(!showDropdown)}
            style={{ cursor: "pointer" }}
          />
                        {/* {unreadCount > 0 && <span className="profile-notification-dot"></span>} */}


          {showDropdown && (
            <div className="profile-dropdown-menu">
              <div className="dropdown-user-info">
                <div className="user-info-header">
                  <div className="user-details">
                <div className="user-name">{usersData?.userName}</div>
                <div className="user-email">{usersData?.email}</div>
              </div>
              <button className="profile-bell">
                <i className="bi bi-bell"></i>
              </button>
</div>
</div>
              <div className="dropdown-divider"></div>
              
              <div
                className="dropdown-item-custom d-flex align-items-center gap-3 p-2 rounded cursor-pointer hover-bg-light"
                style={{ cursor: "pointer", transition: "0.2s" }}
                onClick={() => {
                  setShowProfileModal(true);
                  setShowDropdown(false);
                }}
              >
                <div className="icon-box text-primary">
                  <i className="bi bi-person-gear"></i>
                </div>
                <span className="text-dark small fw-medium">Account</span>
              </div>
            
              <div className="dropdown-item-custom">
                <div className="icon-box">
                  <i className="bi bi-sliders"></i>
                </div>
                <span>Settings</span>
              </div>

              <div className="dropdown-item-custom">
                <div className="icon-box">
                  <i className="bi bi-graph-up-arrow text-primary"></i>
                </div>
                <span>Upgrade Plan</span>
              </div>

              <div className="dropdown-divider"></div>

              <div
                className="dropdown-item-custom logout-item"
                onClick={handleLogout}
                style={{ cursor: "pointer" }}
              >
                <div className="icon-box">
                  <i
                    className="bi bi-box-arrow-right"
                    style={{ color: "red" }}
                  ></i>
                </div>
                <span style={{ color: "red" }}>Log out</span>
              </div>
            </div>
          )}
        </div>
      </div>

      <UserProfileModal
        show={showProfileModal}
        onClose={() => setShowProfileModal(false)}
        currentUser={usersData}
      />
    </div>
  );
};

export default Header;